import { createContext, useContext } from 'react';
import { UseServiceRequestFormFlowReturn } from 'src/components/ServiceRequestForm/CustomHooks/useServiceRequestFormFlow';
import { UseServiceRequestReferenceDataReturn } from 'src/components/ServiceRequestForm/CustomHooks/useServiceRequestReferenceData';

export interface ServiceRequestFormContextValue
  extends UseServiceRequestFormFlowReturn {
  reference: UseServiceRequestReferenceDataReturn;
  user: any;
  from?: string;
  propertyData?: any;
  propertyDisabled?: boolean;
  onClose?: () => void;
  onExit?: () => void;
}

export const ServiceRequestFormContext =
  createContext<ServiceRequestFormContextValue | null>(null);

export const useServiceRequestFormContext = (): ServiceRequestFormContextValue => {
  const context: ServiceRequestFormContextValue = useContext(
    ServiceRequestFormContext
  );

  if (!context) {
    throw new Error(
      'useServiceRequestFormContext must be used within a ServiceRequestForm'
    );
  }

  return context;
};